<template>
  <section class="user-info-about">
    <div v-if="user.first_name" class="cont full-width">
      <p class="label">
        {{$t('users.username')}}
      </p>
      <p class="desc">
        {{user.first_name}} <span v-if="user.second_name"></span>{{user.second_name}}
      </p>
    </div>
    <div class="wrap">
      <div class="cont half-width">
        <p class="label">
          {{$t('users.userId')}}
        </p>
        <p class="desc">
          {{user.id}} <copy-btn :value="user.id"></copy-btn>
        </p>
      </div>
      <div class="cont half-width">
        <p class="label">
          {{$t('users.registered')}}
        </p>
        <p class="desc">
          {{timestampToDataWithTime(user.created_at)}}
        </p>
      </div>
    </div>
    <div  v-if="user.contacts && user.contacts.email"
          class="cont full-width">
      <p class="label">
        {{$t('users.table.email')}}
      </p>
      <a :href="'mailto:'+user.contacts.email"
         class="desc">
        {{user.contacts.email}}
      </a>
    </div>
    <div v-if="user.contacts && user.contacts.phone"
         class="cont full-width">
      <p class="label">
        {{$t('labels.contactPhone')}}
      </p>
      <a :href="'tel:'+user.contacts.phone" class="desc">
        {{user.contacts.phone}}
      </a>
    </div>
    <div type="button" class="del-user">
      {{$t('users.delUser')}}
      <button @click="checkDel"
              class="control-btn hover-red">
        <del-icon :fill="'#ED1C24'"></del-icon>
      </button>
    </div>
  </section>
</template>

<script>
  import copyBtn from '../../copyBtn'
  import {filters} from "../../../mixins/filters";
  import delIcon from '../../Svg/cart_control/delIcon'
  import {delItem} from "../../../mixins/delItem";
  import {mapActions, mapMutations} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";

  export default {
    name: 'userInfoAbout',
    props: {
      user: Object
    },
    mixins: [filters, delItem, tokenAndRoute],
    components: {
      copyBtn,
      delIcon
    },
    methods: {
      ...mapActions({
        deleteUser: 'roles/deleteUser'
      }),
      ...mapMutations({
        setShowRight: 'users/SET_SHOW_INFO',
        setRightInfo: 'users/SET_RIGHT_INFO',
      }),
      checkDel() {
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(this.user.contacts.email)
      },
      deleteItems() {
        this.deleteUser({
          token: this.token,
          id: this.user.id
        });
        this.setShowRight(false);
        this.setRightInfo('');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .user-info-about {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-top: 30px;
  }

  .full-width {
    width: 100%;
  }

  .cont {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
  }

  .label {
    margin-bottom: 10px;
  }

  .desc {
    font-family: $mr;
    font-size: 14px;
    letter-spacing: .25px;

    display: flex;
    align-items: center;

  }

  .del-user {
    margin-top: auto;
    margin-left: auto;
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    color: $red;

    button {
      margin-left: 20px;
      background: $redOp2;
    }
  }
</style>
